import store from '@/store/index'

export default () => {
  const user = store?.getters['users/_user']
  const config = {
    headers: {
      Authorization: `${store?.getters['users/_tokenType']} ${store?.getters['users/_apiRequestToken']}`
    }
  }

  return {
    user,
    config
  }
}
